import Vue from 'vue'
import cookie from './util/cookie'
export default function install(){
  Vue.prototype.sliceDescription = function(description,size){
    let newStr =  description.slice(0,size) + (description.length > size ?  '...' : '')
    return newStr
    // return require(urlString)
  }
  Vue.prototype.firstWordtoUp = function (s) {
    try {
      return s.toLowerCase().replace(/\b([\w|']+)\b/g, function(word) {
          //return word.slice(0, 1).toUpperCase() + word.slice(1);
          return word.replace(word.charAt(0), word.charAt(0).toUpperCase());
      });
    } catch (error) {
      return ''
    }
  }
  Vue.prototype.titleToUpperCase = function (title){
    try {
      return title.toUpperCase()
    } catch (error) {
      return ''
    }
  }
  Vue.prototype.jumpPage = function (component,queryParams) {
    // let toTop = this.$root.$el.scrollTop
    // let toHeight = this.$root.$el.scrollHeight
    let query = queryParams ? queryParams : {}
    this.$router.push({name: component, query: query})
    // this.$root.$el.scrollHeight = 0
    // console.log(toTop,toHeight, '////',this.$root);
  }
  Vue.prototype.toWapChat = function(){
    // let self = this
    let lang = cookie.get('i18nLanguage') || 1
    // console.log(self.$refs);
    window.location.href = "https://chat.melinked.com?key=A714A59BC840FA72AC7AF349A1BF4BA8&lang="+ lang +"&title=MaesInfo"
  }
}
